import { Icon } from 'zarm';

const ZIcon = Icon.createFromIconfont(
  '//at.alicdn.com/t/c/font_3699989_m3fo5cfk6fh.js',
);

export default ZIcon;
